import PersonaDeudasView from "./PersonaDeudasView";

export {PersonaDeudasView}
export default PersonaDeudasView
